import { categoryConstants } from '../_constants';

export function categories(state = {}, action) {
  switch (action.type) {
    case categoryConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.GETALL_SUCCESS:
      return {
        items: action.categories
      };
    case categoryConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function category(state = {}, action) {
  switch (action.type) {
    case categoryConstants.CURRENT_TOPIC:
      return {
        current_topic: action.id
      };
    case categoryConstants.REGISTER_SUCCESS:
      return {
        item: action.category.data
      };
    case categoryConstants.GET_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.GET_SUCCESS:
      return {
        item: action.category.data
      };
    case categoryConstants.GET_FAILURE:
      return {
        error: action.error
      };
    case categoryConstants.DELETE_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.DELETE_SUCCESS:
      return {
        loading: true
      };
    case categoryConstants.DELETE_FAILURE:
      return {
        loading: true
      };
    default:
      return state
  }
}


export function category_sort(state = {}, action) {
  switch (action.type) {
    case categoryConstants.SORT_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.SORT_SUCCESS:
      return {
        item: action.sort
      };
    case categoryConstants.SORT_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function category_append(state = {}, action) {
  switch (action.type) {
    case categoryConstants.APPEND_REQUEST_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.APPEND_SUCCESS:
      return {
        item: action.append
      };
    case categoryConstants.APPEND_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function category_id(state = {}, action) {
  switch (action.type) {
    case categoryConstants.GET_ID_REQUEST:
      return {
        loading: true
      };
    case categoryConstants.GET_ID_SUCCESS:
      return action.category
    case categoryConstants.GET_ID_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
